import { Modal, theme } from "antd";
import styled from "styled-components";

const { defaultAlgorithm, defaultSeed } = theme;
const mapToken = defaultAlgorithm(defaultSeed);

export const StyledModal = styled(Modal)`

    .title-icon {
        margin-inline-end: 12px;
        font-size: 22px;

        &.warning {
            color: ${mapToken.colorWarning};
        }
    }

    .ant-modal-title {
        display: flex;
    }
    
    .ant-modal-body {
        flex-basis: 100%;
        max-width: calc(100% - 34px);
        margin-block-start: 8px;
        margin-inline-start: 34px;
    }
`;
